import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import { ViewVariant } from "@/common/ts/layout";
import { AssetSubscriptionPlanDto } from "@/core/api/generated/v1";

import AssetSubscriptionPaginatedList from "../../../AssetSubscription/ListView/AssetSubscriptionPaginatedList";

interface Props {
  assetSubscriptionPlan: AssetSubscriptionPlanDto;
}

export default function AssetSubscriptionsTabContent({ assetSubscriptionPlan }: Props) {
  return (
    <PageTabContent>
      <ViewLayout displayProps={{ viewVariant: ViewVariant.Tab }}>
        <Stack direction='column' spacing={2}>
          <AssetSubscriptionPaginatedList
            defaultValues={{
              planId: assetSubscriptionPlan.id,
            }}
            displayProps={{
              viewVariant: ViewVariant.Tab,
              header: false,
            }}
          />
        </Stack>
      </ViewLayout>
    </PageTabContent>
  );
}
